import React, {memo, useCallback, useContext} from 'react';
import './_FAQ_List.scss';
import LeftNavigationMenu from "../leftNavigationMenu/leftNavigationMenu";
import {AccordionContext, Card, useAccordionToggle} from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";

const AccordionToggle = ({children, eventKey, callback}) => {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey),
    );

    const isCurrentEventKey = currentEventKey === eventKey;

    return (
        <Accordion.Toggle className={isCurrentEventKey ? 'opened' : ''} as={Card.Header} onClick={decoratedOnClick}>
            {children}
        </Accordion.Toggle>
    );
}

const FAQ_List = ({data, contactData}) => {

    const getCoords = useCallback(elem => {
        const box = elem.getBoundingClientRect();

        const {body} = document;
        const docEl = document.documentElement;

        const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        const clientTop = docEl.clientTop || body.clientTop || 0;

        const top = box.top + scrollTop - clientTop;

        return {top: Math.round(top)};
    }, [])

    const menuData = [
        {type: 'the_festival'},
        {type: 'the_concerts'},
        {type: 'transportation'},
        {type: 'volunteering'}
    ];

    const listData = data && menuData.map((item, i) => {
        return {
            id: i,
            type: item.type,
            data: data[item.type]
        }
    })

    const contact = contactData && contactData.map((item, i) => contactData[contactData.length - i - 1]);

    return (
        <section className='faq_list' id='faq_list'>
            <LeftNavigationMenu getCoords={getCoords} data={menuData} hideOnMobile top={0}/>

            <div className='faqListing'>
                {listData && listData.map((accordion, i) =>
                    <div id={accordion.type} key={accordion.id}>
                        <Accordion>
                            <p className='accordionTitle'>{accordion.type.split('_').join(' ')}</p>
                            {accordion.data.map((card, j) =>
                                <Card key={j}>
                                    <AccordionToggle eventKey={`${i}${j}`}>
                                        {card.question}
                                    </AccordionToggle>
                                    <Accordion.Collapse eventKey={`${i}${j}`}>
                                        <Card.Body dangerouslySetInnerHTML={{__html: card.answer}}/>
                                    </Accordion.Collapse>
                                </Card>
                            )}
                        </Accordion>
                        {accordion.type === "volunteering" &&
                        <>
                            <p className='accordionTitle'>Useful Contacts</p>
                            <div className='usefulContacts'>
                                {contact?.map((item, i) =>
                                    <div key={i}>
                                        <h4>{item.title}</h4>
                                        <div dangerouslySetInnerHTML={{__html: item.contact_info[0]}}/>
                                        <div className='usefulSocial'>
                                            {item.social_media && item.social_media.map(social => {
                                                let mediaImg;
                                                switch (social.type) {
                                                    case 'facebook':
                                                        mediaImg = "/media/icons/inclassica/facebook.svg";
                                                        break;
                                                    case 'youtube':
                                                        mediaImg = "/media/icons/inclassica/youtube.svg";
                                                        break;
                                                    case 'instagram':
                                                        mediaImg = "/media/icons/inclassica/instagram.svg";
                                                        break;
                                                    default:
                                                        mediaImg = "/media/icons/inclassica/twitter.svg";
                                                }
                                                return (
                                                    <div>
                                                        <p>{social.title}</p>
                                                        <a href={`${social.url}`} target="_blank"
                                                           rel='noreferrer noopener'>
                                                            <img src={mediaImg} alt={`${social.title} social icon`}/>
                                                        </a>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                        }
                    </div>
                )}
            </div>
        </section>
    )
}

export default memo(FAQ_List);
